export const PrepurchasedLicenseItemsColumns = (onEditItem) => {
  return [
    // {
    //   title: "Item No",
    //   dataIndex: "ItemNo",
    //   key: "ItemNo",
    //   render: (text, record) => (
    //     <button
    //       type="button"
    //       className="text-blue-600 hover:underline bg-transparent border-0 cursor-pointer p-0 font-inherit"
    //       onClick={(e) => {
    //         e.stopPropagation();
    //         onEditItem(record);
    //       }}
    //     >
    //       {text}
    //     </button>
    //   ),
    // },
    {
      title: "License Item",
      dataIndex: "LicenseItem",
      key: "LicenseItem",
    },
    {
      title: "Old License",
      dataIndex: "OldCodeLabel",
      key: "OldCodeLabel",
      render: (value) => (value === "N/A" ? "" : value || ""),
    },
    {
      title: "Old Price",
      dataIndex: "OldPrice",
      key: "OldPrice",
      render: (value) =>
        value != null && value !== "" ? `$ ${Number(value).toFixed(2)}` : null,
    },
    {
      title: "New License",
      dataIndex: "NewCodeLabel",
      key: "NewCodeLabel",
    },
    {
      title: "New Price",
      dataIndex: "NewPrice",
      key: "NewPrice",
      render: (value) =>
        value != null && value !== "" ? `$ ${Number(value).toFixed(2)}` : null,
    },
    {
      title: "Price",
      dataIndex: "Price",
      key: "Price",
      render: (value) =>
        value != null && value !== "" ? `$ ${Number(value).toFixed(2)}` : null,
    },
    {
      title: "",
      dataIndex: "",
      key: "",
    },
  ];
};
